import { z } from 'zod';

/**
 * The fleet portal layout route's search: the selected client, deep-linkable
 * and retained across every in-portal navigation (`retainSearchParams` on the
 * layout). Absent means "all clients the caller can see".
 *
 * Kept apart from the scope provider so the route's search type does not
 * depend on a module that itself reads the route's search.
 */
export const portalScopeSearchSchema = z.object({
    fleetClientId: z
        .string()
        .regex(/^[1-9]\d*$/)
        .optional()
        .catch(undefined),
});
